module.exports = __webpack_public_path__ + "static/img/pupil.efde508.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/classroom/pupil.svg
// module id = 157
// module chunks = 2